
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import Modal from 'react-modal';
import Select from "react-select";
import { useUser } from "../utils/UserContext";
import { getCurrencySymbol } from '../utils/currencyUtils';
import { toast } from 'react-hot-toast';

function StakeCard({stake_id, coin_id, image, name, symbol, min, max, cycle, roi, price }) {
    const { user } = useUser();
    const [modalIsOpen, setIsOpen] = useState(false);
    const [error, setError] = useState(false);
    const [errorValue, setErrorValue] = useState();
    const [amount, setAmount] = useState();
    const [mainroi, setMainroi] = useState(roi);
    const [usdbal, setUsdbal] = useState(0);
    const [duration, setDuration] = useState("1 day");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
              "Content-Type": "application/json"
          },
          body: JSON.stringify({ fetchCoinBalance: true, coin_id: coin_id })
      })
      .then(response => response.json())
      .then(data => {
          if (data.status === "success") {
            setUsdbal(data.balance);
          }
      })
      .catch(err => {
          console.log(err);
          console.error('Error fetching coin balance!')
      })
    }, [coin_id]);

    function validateAmount (value){
        setAmount(parseFloat(value));
        if(parseFloat(usdbal) === 0){
          setError(true);
          setErrorValue(`Your current balance is 0.00 ${symbol}. Kindly choose a lower amount or deposit into your account.`);
        }else if(parseFloat(value) < parseFloat(min)){
            setError(true);
            setErrorValue(`The minimum allowed amount is ${min} ${symbol}. Please enter a higher amount.`);
        }else if(parseFloat(value) > parseFloat(max)){
            setError(true);
            setErrorValue(`The maximum allowed amount is ${max} ${symbol}. Please enter a lower amount.`);
        }else{
            setError(false);
            setErrorValue("");
        }
    }
    const darkThemeStyles = {
        control: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
          border: "none",
          color: "#fff",
        }),
        menu: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
        }),
        option: (styles, { isFocused, isSelected }) => ({
          ...styles,
          backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
          color: "#fff",
        }),
        singleValue: (styles) => ({
          ...styles,
          color: "#fff",
        }),
    };
    const durationoptions = Array.from({ length: 30 }, (_, i) => ({
      value: (i + 1).toString(),
      label: `${i + 1} day${i === 0 ? '' : 's'}`
    }));
    const ValidateStake = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/stake.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_stake: true, amount: amount, price: price, stake_id : stake_id, coin_id : coin_id, roi : roi, duration : duration })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen(false);
            setTimeout(() => {
                window.location.href = "dashboard";
              }, 2000);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          setLoading(false);
        })
    }
    return (
      <div className="mycard">
        <div className="d-flex align-items-center mb-5">
            <div className="d-flex align-items-center justify-content-center overflow-hidden rounded-circle" style={{width: '35px', height: '35px'}}>
                {image}
            </div>
            <div className="ms-3">
                <p className="text-white fw-bold mb-0 lh-1" style={{fontSize: '16px'}}>{name}</p>
                <p className="text-secondary fw-bold mb-0" style={{fontSize: '16px'}}>{symbol}</p>
            </div>
        </div>
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-secondary">Minumum</p>
            <p className="mb-0 fw-bold text-white">{min} {symbol}</p>
        </div>
        <hr style={{color: '#ffffff47'}}/>
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-secondary">Maximum</p>
            <p className="mb-0 fw-bold text-white">{max} {symbol}</p>
        </div>
        <hr style={{color: '#ffffff47'}}/>
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-secondary">Cycle</p>
            <p className="mb-0 fw-bold text-white">{cycle}</p>
        </div>
        <div className="myBtn bg-prime w-100 text-center mt-4" style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={() => setIsOpen(true)}>Stake</div>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Stake {symbol}</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 ${error ? 'input-error' : ''}`}>
                <input 
                type="text"
                placeholder={min}
                className="inputNone"
                value={amount}
                onChange={(e) => validateAmount(e.target.value)}
                />
                <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>
                {symbol}
                </div>
            </div>
            {error && (
                <p className="mb-0 fw-semibold text-danger mt-1" style={{fontSize: '14px'}}>{errorValue}</p>
            )}
            <div className="d-flex align-items-center justify-content-between mt-2">
                <p className="mb-0 text-secondary fw-bold" style={{fontSize: '13px'}}>Current {symbol} balance</p>
                <p className="mb-0 text-secondary fw-bold" style={{fontSize: '13px'}}>{usdbal} {symbol}</p>
            </div>
            <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Duration:</label>
            <Select 
                options={durationoptions} 
                value={durationoptions.find((opt) => opt.value === duration)}
                onChange={(e) => setDuration(e.value)}
                styles={darkThemeStyles}
                className="w-full"
            />
            <label className="fw-semibold mt-2 mb-1">ROI:</label>
            <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <input 
                type="text"
                placeholder={mainroi}
                className="inputNone"
                readOnly
                value={mainroi+"%"}
                onChange={(e) => setMainroi(e.target.value)}
                />
                <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>%
                </div>
            </div>
            <div className={`myBtn w-100 text-center mt-3 ${!amount?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={amount ? ValidateStake : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Stake'}</div>
        </Modal>
      </div>
    )
  }
  
  export default StakeCard